export default __webpack_public_path__ + "static/changi_airport_group-68178033723198b68ce729c891d3b0a8.png";